import { FC, useContext } from "react";
import {
  Alert,
  Box,
  Button,
} from "@mui/material";
import { AuthContext } from "providers/userProvider";
import { AuthData } from "types/auth";
import { USER_STATUS } from "types/fund-account-invitation";
import { useGetUsersInvitationsQuery, useManageUserInvitationMutation } from "hooks/use-services/fund-account-invitations.service";

interface NewInvitesProps {
}

const NewInvites: FC<NewInvitesProps> = () => {
  const { userData } = useContext<AuthData>(AuthContext);
  const { data: invites, refetch } = useGetUsersInvitationsQuery({
    filter: {
      email: userData?.user?.email!,
      status: USER_STATUS.PENDING,
      expired: false
    }
  })

  const { mutate } = useManageUserInvitationMutation()

  const manageInvite = (invitationId: number, status: USER_STATUS) => {
    mutate({
      invitationId, status
    }, {
      onSuccess: () => refetch()
    });
  }

  // Early return with null if no invites
  if (!invites || invites.data.length === 0) {
    return null;
  }

  return (
    <Alert className='invite' icon={false} sx={{}}>
      You have been invited by {invites.data[0].user.firstName} {invites.data[0].user.lastName} to manage the {invites.data[0].fund.fundAccountName}.
      <Box>
        <Button color="inherit" size="large" onClick={() => manageInvite(invites.data[0].invitationId, USER_STATUS.REJECTED)}>
          Decline request
        </Button>
        <Button variant='outlined' color="inherit" size="large" onClick={() => manageInvite(invites.data[0].invitationId, USER_STATUS.ACCEPTED)}>
          Accept
        </Button>
      </Box>
    </Alert>
  );
};

export default NewInvites;
